import { makeStyles, Theme } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  value: {
    fontSize: 34,
    marginBottom: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
    maxWidth: 280,
    fontSize: 16,
    marginBottom: theme.spacing(3),
    color: '#757575',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    //margin: theme.spacing(10, 0, 0),
  },
  gridPaper: {
    height: '100%',
    padding: theme.spacing(4, 3),
    boxShadow: theme.shadows[0],
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  logo: {
    margin: theme.spacing(2),
  },
  infoContainer: {
    display: 'flex',
    marginBottom: theme.spacing(4),
    height: '25%',
  },
  infoBar: {
    width: '30%',
    height: '100%',
  },
  margin: {
    margin: theme.spacing(1),
  },
  applyButton: {
    margin: theme.spacing(1),
    color: theme.palette.getContrastText(blue[500]),
  },
  select: {
    margin: theme.spacing(1),
    //width: '30%',
  },
  tabsPanel: {
    width: '50%',
  },
  link: {
    color: theme.palette.info.main,
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: 0.15,
  },
}));
